import React from 'react'
// import About from './Components/Pages/About';
import About from './About';
import Contact from './Contact';
import Get from './Get';
import Logos from './Logos';
import Review from './Review'
// import Promotions from './Promotions';
import Products from './Products';
import Services from './Services';
import Footer from './Footer'





export default function Home() {
  return (
    <div>
      <Get></Get>
      <About></About>
      <Logos></Logos> <br/><br/><br/><br/>
      <Review></Review>
      {/* <Promotions></Promotions> */}
      <Products></Products>
      <Services></Services>
     <Contact></Contact>
     <Footer></Footer>
    </div>
  )
}
